import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';

interface RealmAccessBreadcrumbProps {
  realmAccessId: string;
}

export function RealmAccessBreadcrumb({ realmAccessId }: RealmAccessBreadcrumbProps) {
  return getShortenedId(realmAccessId);
}
